export default {
    data() {
        return {

        }
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    methods: {

        async onSubmitDefault() {

            if (this.enabledSubmit) {
                await this.sendingFormDefault()
            } else {
                await this.$emit("beforeSubmit")
            }

        },

        mountedPrepareEmbeddable() {
            this.setValue(this.value)
        },
        mountedContinuedEmbeddable() {
            this.pageFormIsLoaded = true
            this.setIsLoadingPage(false)
            this.$emit("mounted", this.userAuth, this.command)
        },
        setValue(v) {
            this.form = v
        },
        async sendingFormDefault() {

            await this.setSending(
                this.form[this.fieldKey],
                (response) => {
                    this.setRedirect(this.currentPage.path, response[this.fieldKey], this.command, 0, "", true)
                },
            )
        }
    },
    watch: {
        value(v) {
            this.setValue(v)
        },
        form(v) {
            this.$emit("input", v)
        },
        enabledSubmit: async function (newValue, oldValue) {
            if (newValue && !oldValue) {
                //Liberado para continuação

                if(typeof this.onSubmit !== "undefined"){
                    //Página possui sendingForm especifico
                    await this.onSubmit()
                }else{
                    //Demais casos será padrão
                    await this.sendingFormDefault()
                }

            }
        }
    }

}


